<template>
  <!--
    Nachbau echter App-Ansichten mit Fantasiedaten – mit denselben Vuetify-Komponenten,
    Spalten und Farben wie die Originale (user/shootingbook, WaffGComplianceDashboard,
    club/today, user/WorkingHoursList, user/recordtime).
    Wird in Originalgröße gerendert und auf die verfügbare Breite skaliert. Rein dekorativ.
    Wichtig: keine Breakpoint-Klassen (md/sm) verwenden – die reagieren auf das echte Fenster.
  -->
  <div class="preview" :class="{ 'preview--phone': isPhone }" role="img" :aria-label="config.label" data-nosnippet>
    <div v-if="!isPhone" class="preview-chrome" aria-hidden="true">
      <i></i><i></i><i></i>
      <span class="preview-url">schuetzenbuch.de{{ config.path }}</span>
    </div>

    <div
      ref="viewport"
      class="preview-viewport"
      :style="{ height: config.height * scale + 'px' }"
      aria-hidden="true"
      inert
    >
      <div class="preview-screen" :style="screenStyle">
        <!-- App-Leiste wie in views/index.vue -->
        <v-toolbar :height="config.shell === 'user' ? '90px' : '70px'" style="background-color: #32Cd32">
          <v-container fluid class="pa-0">
            <v-row no-gutters align="center">
              <v-col cols="12">
                <div class="d-flex align-center" style="height: 60px;">
                  <v-app-bar-nav-icon></v-app-bar-nav-icon>
                  <img src="/Bilder/book.png" alt="" width="50" height="50" class="rounded-circle mr-3" />
                  <v-toolbar-title v-if="!isPhone" class="text-lowercase white--text d-flex" style="line-height: 1;">
                    schuetzenbuch.de
                  </v-toolbar-title>
                  <v-spacer></v-spacer>
                  <v-btn class="ma-2" color="success">
                    <v-icon>mdi-export</v-icon>
                    <span v-if="!isPhone" class="ml-2">Logout</span>
                  </v-btn>
                </div>
              </v-col>
              <v-col v-if="config.shell === 'user'" cols="12" class="pb-2">
                <div class="d-flex align-center justify-end white--text px-2">
                  <img src="/Bilder/home.png" alt="" class="mr-2 rounded-circle" width="20" height="20" />
                  <span class="text-truncate" style="font-size: 0.875rem;">{{ clubName }}</span>
                </div>
              </v-col>
            </v-row>
          </v-container>
        </v-toolbar>

        <!-- Schießbuch (views/user/shootingbook.vue) -->
        <div v-if="variant === 'shootingbook'" class="mt-4 px-5">
          <h2>Schiessbuch</h2>
          <v-alert dense type="info">
            <b>Tipp:</b>
            <div>
              Hier werden alle beendeten Einträge von dir angezeigt. <br />
              Möchtest du von deinem Verein, ein Training bestätigt bekommen, so klicke auf
              <i class="fas fa-hands-helping"></i> "bestätigen". <br />
              <br /><i class="fas fa-user-graduate"></i> Dein Schuetzenbuch kannst du exportieren, falls du es mal
              bei einem Amt vorlegen möchtest.
            </div>
          </v-alert>

          <v-data-table
            :headers="shootingbookHeaders"
            :items="shootingbook"
            :item-class="shootingbookRowClass"
            :mobile-breakpoint="0"
            disable-sort
            class="elevation-1 mt-8"
          >
            <template v-slot:top>
              <v-toolbar flat dense color="success" dark>
                <v-toolbar-title>Schiessbuch</v-toolbar-title>
                <v-spacer></v-spacer>
                <v-switch :input-value="false" label="Export: Gefiltert" dense hide-details class="mt-0 mr-2"></v-switch>
                <v-btn color="indigo" dark class="mr-5 mb-2 mt-2">
                  PDF
                  <v-icon right>mdi-file-pdf-outline</v-icon>
                </v-btn>
                <v-btn color="indigo" dark class="mr-5 mb-2 mt-2">
                  Excel
                  <v-icon right>mdi-microsoft-excel</v-icon>
                </v-btn>
                <v-btn icon><v-icon>mdi-reload</v-icon></v-btn>
              </v-toolbar>
              <div style="padding: 12px 16px; border-bottom: 1px solid rgba(0,0,0,.12);">
                <v-row dense align="center">
                  <v-col cols="3">
                    <v-text-field
                      label="Suche (Verein, Waffe, Stand, ...)"
                      prepend-inner-icon="mdi-magnify"
                      outlined dense clearable hide-details
                    ></v-text-field>
                  </v-col>
                  <v-col cols="2">
                    <v-select :items="[]" label="Status" outlined dense hide-details></v-select>
                  </v-col>
                  <v-col cols="2">
                    <v-text-field value="2026-01-01" label="Von" type="date" outlined dense hide-details></v-text-field>
                  </v-col>
                  <v-col cols="2">
                    <v-text-field value="2026-09-10" label="Bis" type="date" outlined dense hide-details></v-text-field>
                  </v-col>
                  <v-col cols="auto" class="d-flex align-center">
                    <v-btn text small>
                      <v-icon left small>mdi-filter-off</v-icon>
                      Zurücksetzen
                    </v-btn>
                    <span class="caption grey--text ml-2">{{ shootingbook.length }}/{{ shootingbook.length }}</span>
                  </v-col>
                </v-row>
              </div>
            </template>

            <template v-slot:item.beginn="{ item }">
              {{ formatDate(item.beginn, item.club_id != null) }}
            </template>
            <template v-slot:item.ende="{ item }">
              {{ formatDate(item.club_id != null ? item.ende : item.beginn, item.club_id != null) }}
            </template>

            <template v-slot:item.approval="{ item }">
              <v-btn v-if="item.bestaetigung_status === 1 && item.club_id != null" color="warning" width="180px">
                <v-icon class="mr-2" x-small>fas fa-thumbtack</v-icon>
                zurücknehmen
              </v-btn>
              <v-btn v-if="item.bestaetigung_status === 0 && item.club_id != null" color="info" width="180px">
                <v-icon class="mr-2" x-small>fas fa-hands-helping</v-icon>
                bestätigen
              </v-btn>
              <div v-if="item.bestaetigung_status === 3 && item.club_id != null">
                <div class="error--text caption mb-1">
                  <v-icon x-small color="error">mdi-alert-circle</v-icon>
                  {{ item.abgelehnt_grund }}
                </div>
                <v-btn color="error" width="180px">
                  <v-icon class="mr-2" x-small>fas fa-redo</v-icon>
                  Neu einreichen
                </v-btn>
              </div>
              <div v-if="item.bestaetigung_status === 0 && item.club_id === null">
                <v-btn color="indigo" dark class="mr-5 mb-2" width="200px">
                  <v-icon class="mr-2" x-small>fas fa-signature</v-icon>
                  Signieren
                </v-btn>
              </div>
            </template>

            <template v-slot:item.approvaldate="{ item }">
              <span v-if="item.bestaetigt_vereinDatum">
                Freigegeben am: <br />
                {{ formatDate(item.bestaetigt_vereinDatum, true) }}
              </span>
            </template>

            <template v-slot:item.action="{ item }">
              <div class="d-flex justify-center">
                <v-btn v-if="item.bestaetigung_status !== 2" icon color="info"><v-icon>mdi-pencil</v-icon></v-btn>
                <v-btn v-if="item.bestaetigung_status === 0" icon color="error"><v-icon>mdi-trash-can</v-icon></v-btn>
              </div>
            </template>
          </v-data-table>
        </div>

        <!-- Bedürfnis-Check-Dialog (views/component/weaponTable.vue + WaffGComplianceDashboard.vue) -->
        <div v-if="variant === 'weapons'" class="preview-scrim">
          <v-card class="preview-dialog">
            <v-card-title class="headline grey lighten-2">
              Bedürfnis-Check (§ 14 WaffG)
              <v-spacer></v-spacer>
              <v-btn icon><v-icon>mdi-close</v-icon></v-btn>
            </v-card-title>
            <v-card-text class="pa-0 preview-dialog-body">
              <div class="waffg-dashboard">
                <h2>WaffG-Compliance (§14 WaffG)</h2>

                <v-alert type="info" outlined prominent border="left" class="mt-4 mb-4">
                  <v-row align="center">
                    <v-col class="grow">
                      <div class="text-body-1">
                        <v-icon left color="info">mdi-information</v-icon>
                        <strong>Auswertung deines Schießbuchs für die letzten 24 Monate.</strong>
                      </div>
                    </v-col>
                  </v-row>
                </v-alert>

                <v-row class="mt-4">
                  <v-col v-for="card in weaponCounts" :key="card.title" cols="4">
                    <v-card :color="card.color" dark elevation="3">
                      <v-card-text>
                        <div class="d-flex align-center">
                          <v-icon large class="mr-3">{{ card.icon }}</v-icon>
                          <div>
                            <div class="text-h3 font-weight-bold">{{ card.count }}</div>
                            <div class="text-h6">{{ card.title }}</div>
                            <div class="text-caption">{{ card.caption }}</div>
                          </div>
                        </div>
                      </v-card-text>
                    </v-card>
                  </v-col>
                </v-row>

                <v-alert type="warning" outlined dense class="mt-4">
                  <v-icon left>mdi-alert</v-icon>
                  Du hast <strong>1 Waffe(n)</strong> mit anderem Bedürfnis
                  (z.B. Jagd, Sammlung). Diese werden <strong>nicht</strong> für die Nachweispflicht
                  nach §14 WaffG geprüft.
                </v-alert>

                <v-expansion-panels class="mt-4">
                  <v-expansion-panel>
                    <v-expansion-panel-header>
                      <v-icon left>mdi-chart-pie</v-icon>
                      Waffenübersicht nach Bedürfnis
                    </v-expansion-panel-header>
                  </v-expansion-panel>
                </v-expansion-panels>

                <v-divider class="my-6"></v-divider>

                <v-card outlined class="mb-6 elevation-1">
                  <v-card-title class="pb-2">
                    Ersterwerb (§ 14 Abs. 3)
                    <v-icon small class="ml-2">mdi-information-outline</v-icon>
                  </v-card-title>
                  <v-card-text>
                    <v-row>
                      <v-col cols="6">
                        <div class="mb-1 d-flex justify-space-between">
                          <span>Schießtermine (letzte 12 Monate)</span>
                          <span class="font-weight-bold">24 / 18</span>
                        </div>
                        <v-progress-linear :value="100" color="success" height="12" rounded></v-progress-linear>
                      </v-col>
                      <v-col cols="6">
                        <div class="mb-1 d-flex justify-space-between">
                          <span>Aktive Monate</span>
                          <span class="font-weight-bold">12 / 12</span>
                        </div>
                        <v-progress-linear :value="100" color="success" height="12" rounded></v-progress-linear>
                      </v-col>
                    </v-row>
                    <div class="mt-4 text-center">
                      <v-chip color="success" dark>Voraussetzungen für Ersterwerb erfüllt</v-chip>
                    </div>
                  </v-card-text>
                </v-card>

                <h3 class="text-h5 mb-4 px-2">Fortbestehen des Bedürfnisses</h3>

                <v-card outlined class="mb-6 elevation-1">
                  <v-card-title>Waffen-Übersicht & Compliance</v-card-title>
                  <v-data-table
                    :headers="complianceHeaders"
                    :items="complianceWeapons"
                    :mobile-breakpoint="0"
                    class="elevation-0"
                    hide-default-footer
                    disable-sort
                    dense
                  >
                    <template v-slot:item.beduerfnis="{ item }">
                      <v-chip x-small :color="item.sport ? 'success' : 'grey'" :outlined="!item.sport">
                        {{ item.beduerfnis }}
                      </v-chip>
                    </template>
                    <template v-slot:item.compliance="{ item }">
                      <v-chip v-if="item.sport" small color="success" text-color="white">
                        <v-icon left small>mdi-check-circle</v-icon>
                        Erfüllt
                      </v-chip>
                      <div v-else class="text-caption grey--text">Nicht prüfpflichtig ({{ item.beduerfnis }})</div>
                    </template>
                  </v-data-table>
                </v-card>
              </div>
            </v-card-text>
            <v-divider></v-divider>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="primary" text>Schließen</v-btn>
            </v-card-actions>
          </v-card>
        </div>

        <!-- Heute (views/club/today.vue) -->
        <div v-if="variant === 'today'" class="mt-4 px-5">
          <h2>Heute</h2>
          <v-data-table
            :headers="todaySlHeaders"
            :items="todaySl"
            :mobile-breakpoint="0"
            class="elevation-1 my-2"
            hide-default-footer
            disable-sort
          >
            <template v-slot:top>
              <v-toolbar flat color="warning">
                <h3>Schiessleiter</h3>
                <v-spacer></v-spacer>
                <v-btn icon><v-icon>mdi-reload</v-icon></v-btn>
              </v-toolbar>
            </template>
            <template v-slot:item.beenden>
              <v-btn class="error my-1" text><v-icon>mdi-clock-end</v-icon></v-btn>
            </template>
          </v-data-table>

          <v-data-table
            :headers="todaySaHeaders"
            :items="todaySa"
            :item-class="todaySaRowClass"
            :mobile-breakpoint="0"
            class="elevation-1 my-2"
            hide-default-footer
            disable-sort
          >
            <template v-slot:top>
              <v-toolbar flat color="info">
                <h3>Standaufsicht</h3>
                <v-spacer></v-spacer>
                <v-btn icon><v-icon>mdi-reload</v-icon></v-btn>
              </v-toolbar>
            </template>
            <template v-slot:item.beenden>
              <v-btn class="error my-1" text><v-icon>mdi-clock-end</v-icon></v-btn>
            </template>
            <template v-slot:item.allein_aufsicht="{ item }">
              <v-icon v-if="!item.allein_aufsicht" color="success">mdi-check</v-icon>
              <v-icon v-if="item.allein_aufsicht" color="red">mdi-window-close</v-icon>
            </template>
          </v-data-table>

          <v-data-table
            :headers="todayMemberHeaders"
            :items="todayMembers"
            :mobile-breakpoint="0"
            sort-by="KurzBez"
            group-by="KurzBez"
            class="elevation-1 my-2"
          >
            <template v-slot:top>
              <v-toolbar flat color="success">
                <h3>Schützen</h3>
                <v-spacer></v-spacer>
                <v-btn icon><v-icon>mdi-reload</v-icon></v-btn>
              </v-toolbar>
            </template>
          </v-data-table>
        </div>

        <!-- Arbeitsstunden (views/user/WorkingHoursList.vue) -->
        <div v-if="variant === 'workinghours'" class="mt-4 px-5">
          <h2>Arbeitsstunden Übersicht</h2>
          <v-alert dense type="info">
            <b>Info:</b>
            <div>
              Hier siehst du deine erfassten Arbeitsstunden. <br />
              Einträge müssen eingereicht werden, damit der Verein diese bestätigen kann.
            </div>
          </v-alert>

          <v-data-table
            :headers="workingHoursHeaders"
            :items="workingHours"
            :item-class="workingHoursRowClass"
            :mobile-breakpoint="0"
            disable-sort
            class="elevation-1 mt-8"
          >
            <template v-slot:top>
              <v-toolbar flat dense color="success" dark>
                <v-toolbar-title>Einträge</v-toolbar-title>
                <v-spacer></v-spacer>
                <v-btn icon><v-icon>mdi-reload</v-icon></v-btn>
              </v-toolbar>
              <div style="padding: 12px 16px; border-bottom: 1px solid rgba(0,0,0,.12);">
                <v-row dense align="center">
                  <v-col cols="3">
                    <v-select :items="[]" label="Verein filtern" outlined dense hide-details></v-select>
                  </v-col>
                  <v-col cols="2">
                    <v-text-field label="Von" type="date" outlined dense hide-details></v-text-field>
                  </v-col>
                  <v-col cols="2">
                    <v-text-field label="Bis" type="date" outlined dense hide-details></v-text-field>
                  </v-col>
                  <v-col cols="auto" class="d-flex align-center">
                    <v-btn text small>
                      <v-icon left small>mdi-filter-off</v-icon>
                      Zurücksetzen
                    </v-btn>
                  </v-col>
                </v-row>
              </div>
            </template>

            <template v-slot:item.status="{ item }">
              <v-chip :color="workingHoursStatus[item.bestaetigung_status].color" small dark>
                {{ workingHoursStatus[item.bestaetigung_status].text }}
              </v-chip>
            </template>

            <template v-slot:item.action="{ item }">
              <v-btn v-if="item.bestaetigung_status === 0" color="info" small>
                <v-icon left small>fas fa-hands-helping</v-icon>
                einreichen
              </v-btn>
              <v-btn v-if="item.bestaetigung_status === 1" color="warning" small>
                <v-icon left small>fas fa-thumbtack</v-icon>
                zurücknehmen
              </v-btn>
              <div v-if="item.bestaetigung_status === 3">
                <span class="error--text caption mr-2">
                  <v-icon x-small color="error">mdi-alert-circle</v-icon> Grund
                </span>
                <v-btn color="error" small>
                  <v-icon left small>fas fa-redo</v-icon>
                  Neu einreichen
                </v-btn>
              </div>
            </template>
          </v-data-table>
        </div>

        <!-- Training eintragen, Smartphone (views/user/recordtime.vue + recordshootingtime_form_internaly.vue) -->
        <div v-if="variant === 'phone'" class="mt-4 px-5">
          <v-card class="mt-4 mb-4">
            <v-card-title>Neuer Eintrag im schuetzenbuch</v-card-title>
            <v-divider></v-divider>
            <v-tabs :value="0" background-color="success accent-4" dark>
              <v-tab>schuetzenbuch Eintrag</v-tab>
              <v-tab>Externer Eintrag</v-tab>
            </v-tabs>

            <v-card>
              <v-card-text>
                <v-container fluid class="pa-2">
                  <v-card outlined class="mb-4">
                    <v-card-subtitle class="pb-2">Standort</v-card-subtitle>
                    <v-card-text>
                      <v-select :items="[clubName]" :value="clubName" label="Verein" outlined dense hide-details="auto" class="mb-3"></v-select>
                      <v-select :items="['25m Pistolenstand']" value="25m Pistolenstand" label="Stand" outlined dense hide-details="auto" class="mb-3"></v-select>
                      <v-text-field value="3" label="Bahn" outlined dense hide-details="auto"></v-text-field>
                    </v-card-text>
                  </v-card>

                  <v-card outlined class="mb-4">
                    <v-card-subtitle class="pb-2">Aktivität & Funktion</v-card-subtitle>
                    <v-card-text>
                      <v-select :items="['Schütze']" value="Schütze" label="Funktion" outlined dense hide-details="auto" class="mb-3"></v-select>
                      <v-select :items="['Training']" value="Training" label="Aktivität" outlined dense hide-details="auto"></v-select>
                    </v-card-text>
                  </v-card>

                  <v-card outlined class="mb-4">
                    <v-card-subtitle class="pb-2">Waffe, Disziplin & Zeitpunkt</v-card-subtitle>
                    <v-card-text>
                      <v-tabs :value="0" grow class="mb-3">
                        <v-tab class="text-none">Meine Waffen</v-tab>
                        <v-tab class="text-none">Waffenpool 🎯</v-tab>
                      </v-tabs>
                      <v-select :items="['Walther GSP']" value="Walther GSP" label="Eigene Waffe" outlined dense hide-details="auto" class="mb-3"></v-select>
                      <v-select :items="[discipline]" :value="discipline" label="Disziplin" outlined dense hide-details="auto" class="mb-3">
                        <template v-slot:selection="{ item }">
                          <div class="d-flex flex-column">
                            <span class="font-weight-medium">{{ item.nummer }}</span>
                            <span class="text-caption grey--text text--darken-2">{{ item.text }}</span>
                          </div>
                        </template>
                      </v-select>
                      <v-text-field value="10.09.2026 18:05" label="Begin" outlined dense hide-details="auto"></v-text-field>
                    </v-card-text>
                  </v-card>
                </v-container>
              </v-card-text>
              <v-divider></v-divider>
              <v-card-actions class="px-4 py-3">
                <v-btn color="success" block large>
                  <v-icon left>far fa-save</v-icon>
                  Sichern
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-card>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
const VARIANTS = {
  shootingbook: {
    path: '/user/shootingbook',
    shell: 'user',
    width: 1440,
    height: 860,
    label: 'Beispielansicht: Schießbuch mit bestätigten, eingereichten und externen Einträgen'
  },
  weapons: {
    path: '/user/weapon',
    shell: 'user',
    width: 1280,
    height: 860,
    label: 'Beispielansicht: Bedürfnis-Check nach § 14 WaffG'
  },
  today: {
    path: '/club/today',
    shell: 'club',
    width: 1280,
    height: 860,
    label: 'Beispielansicht: Heute-Ansicht mit Schießleiter, Standaufsicht und Schützen am Stand'
  },
  workinghours: {
    path: '/user/arbeitsstunden',
    shell: 'user',
    width: 1280,
    height: 720,
    label: 'Beispielansicht: Arbeitsstunden mit Status der Freigabe'
  },
  phone: {
    path: '/user/recordtime',
    shell: 'user',
    width: 390,
    height: 844,
    label: 'Beispielansicht: Training auf dem Smartphone eintragen'
  }
};

export default {
  name: 'AppPreview',

  props: {
    variant: {
      type: String,
      required: true,
      validator: v => Object.keys(VARIANTS).includes(v)
    }
  },

  data: () => ({
    scale: 0.4,
    clubName: 'SG Musterhausen 1925 e.V.',

    shootingbookHeaders: [
      { value: 'leer', sortable: false },
      { text: 'Verein', value: 'comp_vereinname' },
      { text: 'Aktivität', value: 'aktivitaet' },
      { text: 'Stand', value: 'KurzBez' },
      { text: 'Bahn', value: 'bahn' },
      { text: 'Funktion', value: 'shooting_function_name' },
      { text: 'Waffe - Kurztext', value: 'KurzT' },
      { text: 'Begin', value: 'beginn' },
      { text: 'Ende', value: 'ende' },
      { text: 'Disziplin', value: 'LangBez' },
      { text: 'Schuss', value: 'tr_schuss' },
      { text: 'Ergebnis', value: 'trergges' },
      { text: 'Verein freigabe', value: 'approval', align: 'center' },
      { text: 'Freigabe', value: 'approvaldate' },
      { text: 'Action', value: 'action', align: 'center' }
    ],
    shootingbook: [
      { id: 1, comp_vereinname: 'SG Musterhausen', aktivitaet: 'Training', KurzBez: '25m', bahn: '3', shooting_function_name: 'Schütze', KurzT: 'Walther GSP', beginn: '2026-09-06 18:10', ende: '2026-09-06 19:25', LangBez: 'Sportpistole', tr_schuss: 60, trergges: 541, club_id: 1, bestaetigung_status: 1, bestaetigt_vereinDatum: null },
      { id: 2, comp_vereinname: 'SG Musterhausen', aktivitaet: 'Training', KurzBez: '25m', bahn: '1', shooting_function_name: 'Standaufsicht', KurzT: 'CZ Shadow 2', beginn: '2026-08-30 17:30', ende: '2026-08-30 20:00', LangBez: 'Pistole 9mm Luger', tr_schuss: 90, trergges: '', club_id: 1, bestaetigung_status: 0, bestaetigt_vereinDatum: null },
      { id: 3, comp_vereinname: 'SV Nachbardorf', aktivitaet: 'Wettkampf', KurzBez: '', bahn: '', shooting_function_name: 'Schütze', KurzT: 'Anschütz 1907', beginn: '2026-08-23 00:00', ende: '2026-08-23 00:00', LangBez: 'KK-Gewehr 50m liegend', tr_schuss: 60, trergges: 587, club_id: null, bestaetigung_status: 0, bestaetigt_vereinDatum: null },
      { id: 4, comp_vereinname: 'SG Musterhausen', aktivitaet: 'Training', KurzBez: '50m', bahn: '5', shooting_function_name: 'Schütze', KurzT: 'Anschütz 1907', beginn: '2026-08-16 10:00', ende: '2026-08-16 11:40', LangBez: 'KK-Gewehr 50m liegend', tr_schuss: 60, trergges: 583, club_id: 1, bestaetigung_status: 2, bestaetigt_vereinDatum: '2026-08-17 19:02' },
      { id: 5, comp_vereinname: 'SG Musterhausen', aktivitaet: 'Training', KurzBez: '25m', bahn: '2', shooting_function_name: 'Schütze', KurzT: 'Walther GSP', beginn: '2026-08-09 18:00', ende: '2026-08-09 19:15', LangBez: 'Sportpistole', tr_schuss: 60, trergges: 536, club_id: 1, bestaetigung_status: 2, bestaetigt_vereinDatum: '2026-08-10 20:15' },
      { id: 6, comp_vereinname: 'SG Musterhausen', aktivitaet: 'Training', KurzBez: '25m', bahn: '4', shooting_function_name: 'Schütze', KurzT: 'CZ Shadow 2', beginn: '2026-08-02 18:20', ende: '2026-08-02 19:30', LangBez: 'Pistole 9mm Luger', tr_schuss: 80, trergges: '', club_id: 1, bestaetigung_status: 3, bestaetigt_vereinDatum: null, abgelehnt_grund: 'Uhrzeit bitte prüfen' }
    ],

    weaponCounts: [
      { title: 'Sportwaffen', caption: '§14 WaffG - Prüfpflichtig', count: 3, color: 'success', icon: 'mdi-target' },
      { title: 'Andere Waffen', caption: 'Nicht prüfpflichtig', count: 1, color: 'grey darken-1', icon: 'mdi-pistol' },
      { title: 'Gesamt', caption: 'Alle Waffen', count: 4, color: 'primary', icon: 'mdi-sword-cross' }
    ],
    complianceHeaders: [
      { text: 'Waffe', value: 'name', align: 'start' },
      { text: 'Typ', value: 'gattung' },
      { text: 'Kaliber', value: 'kaliber' },
      { text: 'Bedürfnis', value: 'beduerfnis' },
      { text: 'Status', value: 'compliance' }
    ],
    complianceWeapons: [
      { name: 'Walther GSP', gattung: 'Pistole', kaliber: '.22 lr', beduerfnis: 'Sportschütze', sport: true },
      { name: 'CZ Shadow 2', gattung: 'Pistole', kaliber: '9mm Luger', beduerfnis: 'Sportschütze', sport: true },
      { name: 'Anschütz 1907', gattung: 'Gewehr', kaliber: '.22 lr', beduerfnis: 'Sportschütze', sport: true },
      { name: 'Merkel Bockflinte', gattung: 'Flinte', kaliber: '12/76', beduerfnis: 'Jäger', sport: false }
    ],

    todaySlHeaders: [
      { text: 'Name', value: 'name', align: 'left', width: '250px' },
      { text: 'Vorname', value: 'vorname', align: 'left', width: '250px' },
      { text: 'Begin', value: 'BeginFormat', align: 'left', width: '250px' },
      { text: 'Aufsicht Regulär', align: 'center', value: 'allein_aufsicht', width: '100px' },
      { text: 'Beenden', value: 'beenden', align: 'right', width: '250px' }
    ],
    todaySaHeaders: [
      { text: 'Name', value: 'name', align: 'left', width: '250px' },
      { text: 'Vorname', value: 'vorname', align: 'left', width: '250px' },
      { text: 'Begin', value: 'BeginFormat', align: 'left', width: '250px' },
      { text: 'Stand', value: 'KurzBez', align: 'left', width: '250px' },
      { text: 'Aufsicht Regulär', align: 'center', value: 'allein_aufsicht', width: '100px' },
      { text: 'Beenden', value: 'beenden', align: 'right', width: '250px' }
    ],
    todayMemberHeaders: [
      { text: 'Name', value: 'name', align: 'left', width: '250px', sortable: false },
      { text: 'Vorname', value: 'vorname', align: 'left', width: '250px' },
      { text: 'Begin', value: 'BeginFormat', align: 'left', width: '250px' },
      { text: 'Stand', value: 'KurzBez', align: 'left', width: '250px' },
      { text: 'Bahn', value: 'bahn', align: 'left', width: '250px' }
    ],
    todaySl: [{ name: 'Brandt', vorname: 'Klaus', BeginFormat: '10.09.2026 17:30' }],
    todaySa: [
      { name: 'Wagner', vorname: 'Sabine', BeginFormat: '10.09.2026 17:45', KurzBez: '25m Pistole', allein_aufsicht: 0 },
      { name: 'Becker', vorname: 'Tom', BeginFormat: '10.09.2026 18:00', KurzBez: '50m Gewehr', allein_aufsicht: 1 }
    ],
    todayMembers: [
      { name: 'Keller', vorname: 'Max', BeginFormat: '10.09.2026 18:05', KurzBez: '25m Pistole', bahn: '2' },
      { name: 'Hoffmann', vorname: 'Julia', BeginFormat: '10.09.2026 18:20', KurzBez: '25m Pistole', bahn: '4' },
      { name: 'Schneider', vorname: 'Lukas', BeginFormat: '10.09.2026 17:50', KurzBez: '50m Gewehr', bahn: '1' },
      { name: 'Yilmaz', vorname: 'Deniz', BeginFormat: '10.09.2026 18:10', KurzBez: '50m Gewehr', bahn: '3' }
    ],

    workingHoursHeaders: [
      { text: 'Verein', value: 'club_name' },
      { text: 'Tätigkeit', value: 'funktion_name' },
      { text: 'Einsatz', value: 'arbeitseinsatz_titel' },
      { text: 'Beginn', value: 'BeginFormat' },
      { text: 'Ende', value: 'EndeFormat' },
      { text: 'Status', value: 'status' },
      { text: 'Aktion', value: 'action', align: 'center' }
    ],
    workingHours: [
      { id: 1, club_name: 'SG Musterhausen', funktion_name: 'Kugelfang reinigen', arbeitseinsatz_titel: 'Herbstputz 2026', BeginFormat: '12.09.2026 09:00', EndeFormat: '12.09.2026 12:00', bestaetigung_status: 0 },
      { id: 2, club_name: 'SG Musterhausen', funktion_name: 'Rasen mähen', arbeitseinsatz_titel: '', BeginFormat: '29.08.2026 17:00', EndeFormat: '29.08.2026 19:30', bestaetigung_status: 1 },
      { id: 3, club_name: 'SG Musterhausen', funktion_name: 'Standaufsicht', arbeitseinsatz_titel: '', BeginFormat: '30.08.2026 17:30', EndeFormat: '30.08.2026 20:00', bestaetigung_status: 2 },
      { id: 4, club_name: 'SG Musterhausen', funktion_name: 'Vereinsfest Aufbau', arbeitseinsatz_titel: 'Sommerfest 2026', BeginFormat: '05.07.2026 08:00', EndeFormat: '05.07.2026 12:00', bestaetigung_status: 2 },
      { id: 5, club_name: 'SG Musterhausen', funktion_name: 'Hecke schneiden', arbeitseinsatz_titel: 'Frühjahrsputz 2026', BeginFormat: '18.04.2026 09:00', EndeFormat: '18.04.2026 15:00', bestaetigung_status: 3 }
    ],
    workingHoursStatus: {
      0: { text: 'Nicht eingereicht', color: 'grey' },
      1: { text: 'Eingereicht', color: 'info' },
      2: { text: 'Bestätigt', color: 'success' },
      3: { text: 'Abgelehnt', color: 'error' }
    },

    discipline: { nummer: 'DSB 2.40', text: 'Sportpistole' }
  }),

  computed: {
    config() {
      return VARIANTS[this.variant];
    },
    isPhone() {
      return this.variant === 'phone';
    },
    screenStyle() {
      return {
        width: this.config.width + 'px',
        height: this.config.height + 'px',
        transform: `scale(${this.scale})`
      };
    }
  },

  mounted() {
    this.updateScale();
    if (window.ResizeObserver) {
      this.resizeObserver = new ResizeObserver(() => this.updateScale());
      this.resizeObserver.observe(this.$refs.viewport);
    } else {
      window.addEventListener('resize', this.updateScale);
    }
  },

  beforeDestroy() {
    if (this.resizeObserver) this.resizeObserver.disconnect();
    window.removeEventListener('resize', this.updateScale);
  },

  methods: {
    updateScale() {
      const width = this.$refs.viewport && this.$refs.viewport.clientWidth;
      if (width) this.scale = width / this.config.width;
    },
    formatDate(value, withTime) {
      const options = withTime ? { dateStyle: 'short', timeStyle: 'short' } : { dateStyle: 'short' };
      return new Date(value.replace(' ', 'T')).toLocaleString('de-DE', options);
    },
    // Zeilenfarben wie in den Originalen
    shootingbookRowClass(item) {
      return { 2: 'green lighten-4', 1: 'amber lighten-4', 3: 'red lighten-5' }[item.bestaetigung_status] || '';
    },
    todaySaRowClass(item) {
      return item.allein_aufsicht === 1 ? 'blue lighten-4' : '';
    },
    workingHoursRowClass(item) {
      return { 2: 'green lighten-5', 1: 'blue lighten-5', 3: 'red lighten-5' }[item.bestaetigung_status] || '';
    }
  }
};
</script>

<style scoped>
.preview {
  border-radius: 10px;
  background: #fff;
  box-shadow: 0 22px 44px -20px rgba(20, 45, 20, 0.35), 0 2px 6px rgba(0, 0, 0, 0.08);
  overflow: hidden;
  user-select: none;
}

.preview-chrome {
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 8px 12px;
  background: #eef1ec;
}

.preview-chrome i {
  display: block;
  width: 9px;
  height: 9px;
  border-radius: 50%;
  background: #cfd6cc;
}

.preview-url {
  flex: 1;
  margin-left: 10px;
  padding: 2px 10px;
  border-radius: 6px;
  background: #fff;
  color: #6b776d;
  font-size: 11px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.preview-viewport {
  position: relative;
  overflow: hidden;
  pointer-events: none;
}

.preview-screen {
  position: absolute;
  top: 0;
  left: 0;
  overflow: hidden;
  background: #fff;
  transform-origin: 0 0;
  text-align: left;
}

.preview--phone {
  border: 10px solid #1d2a1f;
  border-radius: 30px;
}

/* Dialog wie v-dialog scrollable, width 900px */
.preview-scrim {
  position: absolute;
  inset: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(33, 33, 33, 0.46);
}

.preview-dialog {
  display: flex;
  flex-direction: column;
  width: 900px;
  height: 90%;
}

.preview-dialog-body {
  flex: 1 1 auto;
  overflow: hidden;
}

.waffg-dashboard {
  max-width: 56rem;
  margin: 0 auto;
  padding: 1rem;
}
</style>
